import { ErrorView } from "@/components/ui/layout/error/errorView"
import {
  CoachCategoryFormView,
  type CoachCategoryFormViewRef,
} from "@modules/coachCategories/components/coachCategoryFormView"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { Suspense, useRef } from "react"
import { ErrorBoundary } from "react-error-boundary"

export function useCoachCategoryFormSidebar() {
  const { sidebarNavigateTo } = useSidebar()
  const formViewRef = useRef<CoachCategoryFormViewRef>(null)

  const navigateToCoachCategoryCreation = () => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <CoachCategoryFormView ref={formViewRef} />
          </Suspense>
        </ErrorBoundary>
      ),
      onHide: () => formViewRef.current?.onClose() ?? Promise.resolve(true),
    })
  }

  const navigateToCoachCategoryEdition = (categoryId: string) => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <CoachCategoryFormView ref={formViewRef} categoryId={categoryId} />
          </Suspense>
        </ErrorBoundary>
      ),
      onHide: () => formViewRef.current?.onClose() ?? Promise.resolve(true),
    })
  }

  return { navigateToCoachCategoryCreation, navigateToCoachCategoryEdition }
}
